export const queryServer = async (callbackFunc, payload, rejectWithValue) => {
    try {
        const response = await callbackFunc(payload);
        if (! response.ok) {
            throw new Error(`Received error ${response.status}`);
        }
        return response;
    } catch (e) {
        return rejectWithValue(e.message);
    }
};

export const plataformas = [
    '',
    'Alcalá de Henares',
    'Arganzuela',
    'Atocha',
    'Estrecho',
    'Fuenlabrada',
    'Sol',
    'Pan Bendito',
    'Parla',
    'Pº de Extremadura',
    'Puertollano',
    'Garelli',
];

export const escenarios = [
    'Suceso en la vida de la persona vulnerable (fuera de nuestras actividades)',
    'Suceso entre iguales',
    'Conducta autolesiva',
    'Suceso en nuestras actividades (vulneración Código de Conducta)'
];

export const tiposViolencia = [
    '',
    'Física (golpes, empujones, castigos físicos, agresiones).',
    'Psicológica o emocional (insultos, amenazas, humillaciones, desprecios, manipulación afectiva).',
    'Sexual (abuso, acoso, agresión sexual, explotación, grooming, exhibicionismo).',
    'Negligencia o abandono (falta de cuidado físico o emocional, desprotección, desatención de necesidades).',
    'Violencia de género (violencia basada en la desigualdad de género que afecta directamente o indirectamente a niños y niñas).',
    'Económica o patrimonial (explotación del trabajo infantil, uso del menor para obtener recursos).',
    'Institucional (maltrato o desatención por parte de entidades públicas o privadas responsables del cuidado: escuelas, centros de protección, juzgados, etc.).',
    'Entre iguales / bullying (acoso físico, verbal, psicológico o virtual entre menores).',
    'Cibernética o digital (ciberacoso, sexting, grooming, difusión de imágenes sin consentimiento).',
    'Violencia estructural o social (discriminación, pobreza, exclusión social que generan daño o desventaja).',
    'Explotación y trata (trata de personas menores, trabajos forzosos, utilización para actividades delictivas o sexuales).'
];

export const ambitos  = [
    '',
    'Familiar / Hogar (ejemplos: violencia física, emocional, negligencia, violencia de género, abuso sexual).',
    'Escolar / Educativo (ejemplos: bullying, acoso del profesorado, negligencia institucional, discriminación).',
    'Institucional (ejemplos: desprotección, trato degradante, negligencia en centros de acogida, justicia, salud).',
    'Laboral / Formación (ejemplos: explotación infantil, trabajo forzoso, maltrato de aprendices o jóvenes en prácticas).',
    'Entorno digital (ejemplos: ciberacoso, sexting, grooming, exposición a contenidos inapropiados o violentos).',
    'Ocio / Deportivo (ejemplos: violencia verbal o física, abusos, presión extrema, negligencia emocional).',
    'Comunitario / Calle (ejemplos: violencia entre iguales, bandas, discriminación por origen, orientación o religión).',
    'Entorno policial o judicial (ejemplos: trato inadecuado, intimidación, revictimización, falta de garantías procesales).',
    'Ámbito sanitario (ejemplos: falta de atención, trato negligente, mala praxis institucional).'
];

export const motivosCierre = [
    '',
    'Se han tomado medidas en nuestros programas',
    'Se ha puesto en conocimiento de Cuerpos y Fuerzas de Seguridad',
    'Se ha puesto en conocimiento de los Servicios Sociales',
    'Se ha puesto en conocimiento de Fiscalía',
    'Otras medidas'
];

export const writeSentenceFromArray = (list) => {
    const sentence = list.length === 0 ? '' :
        list.length === 1 ? list[0] :
            list.length === 2 ? list.join(' y ') :
                list.slice(0, -1).join(', ') + ' y ' + list[list.length - 1];
    return sentence;
};

export const writeListFromArray = (list) => {
    const sentence = list.length === 0 ? '' :
        list.length === 1 ? list[0] :
            list.join(', ');
    return sentence;
};
